export default [{
        path: '/exchange',
        name: 'Exchange',
        component: () => import('../../views/coupon/Exchange.vue'),
        meta: {
            title: '兑换订单详情',
            keepAlive: false,
        }
    },
    {
        path: '/shop',
        name: 'Shop',
        component: () => import('../../views/coupon/Shop.vue'),
        meta: {
            title: '积分兑换',
            keepAlive: false,
        }
    },
    {
        path: '/changeOrder',
        name: 'ChangeOrder',
        component: () => import('../../views/coupon/ChangeOrder.vue'),
        meta: {
            title: '积分兑换记录',
            keepAlive: false,
        }
    },
    {
        path: '/getCoupon',
        name: 'GetCoupon',
        component: () => import('../../views/coupon/GetCoupon.vue'),
        meta: {
            title: '领取优惠券',
            keepAlive: false,
        }
    },
    {
        path: '/photo',
        name: 'Photo',
        component: () => import('../../views/coupon/Photo.vue'),
        meta: {
            title: '拍照赢积分',
            keepAlive: false,
        }
    },
    {
        path: '/confirm',
        name: 'Confirm',
        component: () => import('../../views/coupon/Confirm.vue'),
        meta: {
            title: '确认兑换',
            keepAlive: false,
        }
    },
    {
        path: '/shopDetails',
        name: 'ShopDetails',
        component: () => import('../../views/coupon/ShopDetails.vue'),
        meta: {
            title: '商品详情',
            keepAlive: false,
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/coupon.js